import React from "react";

export default function Hotel({ color }) {
  return (
    <svg
      id="Group_331"
      dataname="Group 331"
      xmlns="http://www.w3.org/2000/svg"
      width="18.001"
      height="18"
      viewBox="0 0 18.001 18"
      className={color}
    >
      <path
        id="Path_135"
        dataname="Path 135"
        d="M22,24h1a.945.945,0,0,0,1-1V14a.945.945,0,0,0-1-1H22Z"
        transform="translate(-6 -6.002)"
      />
      <path
        id="Path_136"
        dataname="Path 136"
        d="M2,23V13H1a.945.945,0,0,0-1,1v9a.945.945,0,0,0,1,1H2Z"
        transform="translate(0.002 -6.002)"
      />
      <path
        id="Path_137"
        dataname="Path 137"
        d="M13.373,0H4.625A.7.7,0,0,0,4,.75v16.5a.7.7,0,0,0,.625.75H7.749V15.374A.348.348,0,0,1,8.062,15H9.936a.348.348,0,0,1,.312.375V18h3.124a.7.7,0,0,0,.625-.75V.75A.7.7,0,0,0,13.373,0ZM7.437,12.749H6.187a.348.348,0,0,1-.312-.375v-.75a.348.348,0,0,1,.312-.375h1.25a.348.348,0,0,1,.312.375v.75A.348.348,0,0,1,7.437,12.749Zm0-3H6.187a.348.348,0,0,1-.312-.375v-.75a.348.348,0,0,1,.312-.375h1.25a.348.348,0,0,1,.312.375v.75A.348.348,0,0,1,7.437,9.749Zm0-3H6.187a.348.348,0,0,1-.312-.375v-.75a.348.348,0,0,1,.312-.375h1.25a.348.348,0,0,1,.312.375v.75A.348.348,0,0,1,7.437,6.749Zm0-3H6.187a.348.348,0,0,1-.312-.375v-.75a.348.348,0,0,1,.312-.375h1.25a.348.348,0,0,1,.312.375v.75A.348.348,0,0,1,7.437,3.75Zm4.374,9h-1.25a.348.348,0,0,1-.312-.375v-.75a.348.348,0,0,1,.312-.375h1.25a.348.348,0,0,1,.312.375v.75A.348.348,0,0,1,11.811,12.749Zm0-3h-1.25a.348.348,0,0,1-.312-.375v-.75a.348.348,0,0,1,.312-.375h1.25a.348.348,0,0,1,.312.375v.75A.348.348,0,0,1,11.811,9.749Zm0-3h-1.25a.348.348,0,0,1-.312-.375v-.75a.348.348,0,0,1,.312-.375h1.25a.348.348,0,0,1,.312.375v.75A.348.348,0,0,1,11.811,6.749Zm0-3h-1.25a.348.348,0,0,1-.312-.375v-.75a.348.348,0,0,1,.312-.375h1.25a.348.348,0,0,1,.312.375v.75A.348.348,0,0,1,11.811,3.75Z"
        transform="translate(0.002)"
      />
    </svg>
  );
}
